export function get_form_url(name: string): string {
  const formUrls: Record<string, string> = {
    'Newsletter Signup': 'https://readdy.ai/api/form/d9cf7omdn0rfb35c5lq0',
  };
  return formUrls[name] || '';
}